export default "__VITE_ASSET__BwsijZUQ__"